import { SupportComponent } from './landing-pages/support/support.component';
import { SequanseComponent } from './Data/company/sequanse/sequanse.component';
import { UpdateOfferPriceComponent } from './Data/offer-price/update-offer-price/update-offer-price.component';
import { AddOfferPriceComponent } from './Data/offer-price/add-offer-price/add-offer-price.component';
import { OfferPriceComponent } from './Data/offer-price/offer-price.component';
import { UpdateOrderComponent } from './Data/order/update-order/update-order.component';
import { AddOrderComponent } from './Data/order/add-order/add-order.component';
import { UpdateMissionComponent } from './Data/Mission/update-mission/update-mission.component';
import { AddMissionComponent } from './Data/Mission/add-mission/add-mission.component';
import { MissionComponent } from './Data/Mission/Mission.component';
import { HistoryDetailsComponent } from './Data/upload-permanent-file/history/history-details/history-details.component';
import { CompanyEmployeeComponent } from './Data/Accountant/office-companies/company-employee/company-employee.component';
import { HistoryComponent } from './Data/upload-permanent-file/history/history.component';
import { AllMerchantUsersComponent } from './Data/merchant/all-merchant-users/all-merchant-users.component';
import { AllUsersOfficeComponent } from './Data/accounting-offices/all-users-office/all-users-office.component';
import { UploadAllocationNumberComponent } from './Data/upload-allocation-number/uploadAllocationNumber.component';
import { MoreInfoCompanyComponent } from './Data/company/more-info-company/more-info-company.component';
import { UpdateReceiptComponent } from './Data/receipts/update-receipt/update-receipt.component';

import { UpdateReverceInvoiceComponent } from './Data/reverce-invoice/update-reverce-invoice/update-reverce-invoice.component';
import { ExportReverceInvoicePdfComponent } from './Data/reverce-invoice/export-reverce-invoice-pdf/export-reverce-invoice-pdf.component';
import { AddReverceInvoiceComponent } from './Data/reverce-invoice/add-reverce-invoice/add-reverce-invoice.component';
import { ReversereceiptComponent } from './Data/reverce-invoice/reversereceipt/reversereceipt.component';
import { ReverceInvoiceComponent } from './Data/reverce-invoice/reverce-invoice.component';
import { UploadPermanentFileComponent } from './Data/upload-permanent-file/upload-permanent-file.component';
import { ExportReportsComponent } from './Data/Accountant/export-reports/export-reports.component';
import { DocumentPdfComponent } from './Data/Accountant/document-pdf/document-pdf.component';
import { CompanyDocumentsComponent } from './Data/Accountant/company-documents/company-documents.component';
import { AccountantsComponent } from './Data/accountants/accountants.component';
import { AccountantUserCompaniesComponent } from './Data/Accountant/accountant-user-companies/accountant-user-companies.component';
import { OfficeCompaniesComponent } from './Data/Accountant/office-companies/office-companies.component';
import { OfficeUsersPrivilegesComponent } from './Data/Accountant/office-users-privileges/office-users-privileges.component';
import { OfficeUsersComponent } from './Data/Accountant/office-users/office-users.component';
import { OfficeComponent } from './Data/Accountant/office/office.component';
import { NotificationDetailsComponent } from './shared/components/header/elements/notification/notification-details/notification-details.component';
import { NotificationCenterComponent } from './shared/components/notification-center/notification-center.component';
import { AccountingOfficesCompaniesComponent } from './Data/accounting-offices/accounting-offices-companies/accounting-offices-companies.component';
import { AccountingOfficesComponent } from './Data/accounting-offices/accounting-offices.component';
import { ExportFinaicalRequestPdfComponent } from './Data/finaical-request/export-finaical-request-pdf/export-finaical-request-pdf.component';
import { ExportInvoiceWithReceiptPdfComponent } from './Data/invoice-and-receipt/export-invoice-with-receipt-pdf/export-invoice-with-receipt-pdf.component';
import { TermsComponent } from './Data/terms/terms.component';
import { UpdateFinaicalRequestComponent } from './Data/finaical-request/update-finaical-request/update-finaical-request.component';
import { FinaicalRequestComponent } from './Data/finaical-request/finaical-request.component';
import { AppInfoComponent } from './Data/app-info/app-info.component';
import { PermanentFileComponent } from './Data/permanent-file/permanent-file.component';
import { ExportReceiptPdfComponent } from './Data/receipts/export-receipt-pdf/export-receipt-pdf.component';
import { AdminGuard } from './admin.guard';
import { DocumentsRedirectGuard } from './documents-redirect.guard';
import { ExportPdfComponent } from './Data/invoices/export-pdf/export-pdf.component';
import { UpdateInvoiceComponent } from './Data/invoices/update-invoice/update-invoice.component';
import { AddInvoiceComponent } from './Data/invoices/add-invoice/add-invoice.component';
import { InvoicesComponent } from './Data/invoices/invoices.component';
import { PaymentMethodComponent } from './Data/payment-method/payment-method.component';
import { BanksBranchesComponent } from './Data/banks/banks-branches/banks-branches.component';
import { BanksComponent } from './Data/banks/banks.component';
import { VatListDetailsComponent } from './Data/vat-list/vat-list-details/vat-list-details.component';
import { ReceiptsComponent } from './Data/receipts/receipts.component';
import { UsersPrivilegesComponent } from './Data/users-privileges/users-privileges.component';
import { MeasurementUnitsComponent } from './Data/measurement-units/measurement-units.component';
import { CategoriesComponent } from './Data/categories/categories.component';
import { VatListComponent } from './Data/vat-list/vat-list.component';
import { AdminExpenseQuotaComponent } from './Data/admin-expense-quota/admin-expense-quota.component';
import { AdminPushNotificationsComponent } from './Data/admin-push-notifications/admin-push-notifications.component';
import { AdminOutletComponent } from './components/admin/admin-outlet.component';
import { UpdateCompanyComponent } from './Data/company/update-company/update-company.component';
import { ViewCompanyComponent } from './Data/company/view-company/view-company.component';
import { ViewMerchantComponent } from './Data/merchant/view-merchant/view-merchant.component';
import { UpdateMerchantComponent } from './Data/merchant/update-merchant/update-merchant.component';
import { MerchantComponent } from './Data/merchant/merchant.component';
import { PlaneDetailsComponent } from './components/dashboard/plane-details/plane-details.component';
import { CompanyComponent } from './Data/company/company.component';
import { PlansComponent } from './Auth/plans/plans.component';
import { ResendotpComponent } from './Auth/resendotp/resendotp.component';
import { OtpComponent } from './Auth/otp/otp.component';
import { TrustedDevicesComponent } from './Auth/trusted-devices/trusted-devices.component';
import { AuthGuard } from './auth.guard';
import { Error404Component } from './Auth/error404/error404.component';
import { SubPlansComponent } from './landing-pages/sub-plans/sub-plans.component';
import { ForgotPasswordComponent } from './Auth/forgot-password/forgot-password.component';
import { LoginComponent } from './Auth/login/login.component';
import { RegisterComponent } from './Auth/register/register.component';
import { TermsAndConditionsComponent } from './landing-pages/terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from './landing-pages/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './landing-pages/terms-of-service/terms-of-service.component';
import { AboutComponent } from './landing-pages/about/about.component';
import { AutoLoginComponent } from './Auth/auto-login/auto-login.component';
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent } from "./landing-pages/home/home.component";
import { CampaignLandingComponent } from './landing-pages/campaign-landing/campaign-landing.component';
import { ThiArticlesComponent } from './landing-pages/thi-articles/thi-articles.component';
import { ThiArticleDetailComponent } from './landing-pages/thi-articles/thi-article-detail.component';
import { FirstPageComponent } from './components/simple-page/first-page/first-page.component';
import { ContentComponent } from './shared/components/layout/content/content.component';
import { FullComponent } from './shared/components/layout/full/full.component';
import { content } from "./shared/routes/routes";
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { PlansInfoComponent } from './Data/plans-info/plans-info.component';
import { CustomersComponent } from './Data/customers/customers.component';
import { CustomerBalancesComponent } from './Data/customer-balances/customer-balances.component';
import { CustomerAccountEntriesComponent } from './Data/customer-account-entries/customer-account-entries.component';
import { CustomerAccountCardComponent } from './Data/customer-account-card/customer-account-card.component';
import { ChecksReportComponent } from './Data/checks-report/checks-report.component';
import { ProductsComponent } from './Data/products/products.component';
import { ProductFormComponent } from './Data/products/product-form/product-form.component';
import { MerchantProductCategoriesComponent } from './Data/merchant-product-categories/merchant-product-categories.component';
import { InvoicesTypesComponent } from './Data/invoices-types/invoices-types.component';
import { UsersComponent } from './Data/users/users.component';
import { AddReceiptsComponent } from './Data/receipts/add-receipts/add-receipts.component';
import { AddFinaicalRequestComponent } from './Data/finaical-request/add-finaical-request/add-finaical-request.component';
import { InvoiceAndReceiptComponent } from './Data/invoice-and-receipt/invoice-and-receipt.component';
import { AddInvoiceWithReceiptComponent } from './Data/invoice-and-receipt/add-invoice-with-receipt/add-invoice-with-receipt.component';
import { UpdateInvoiceWithReceiptComponent } from './Data/invoice-and-receipt/update-invoice-with-receipt/update-invoice-with-receipt.component';
import { DocumentsComponent } from './Data/company/documents/documents.component';
import { OrderComponent } from './Data/order/order.component';
import { AllWarningComponent } from './shared/components/header/elements/message-box/all-warning/all-warning.component';
import { ClosedMonthComponent } from './Data/Accountant/company-documents/closed-month/closed-month.component';
import { MerchantDocumentsComponent } from './Data/merchant/merchant-documents/merchant-documents.component';
import { MerchantPaymentComponent } from './Data/merchant/merchant-payment/merchant-payment.component';
import { MerchantSubscriptionsComponent } from './Data/merchant/merchant-subscriptions/merchant-subscriptions.component';
import { CheckoutComponent } from './components/checkout/checkout.component';
import { DocumentComponent } from './components/document/document.component';
import { TranslationAdminComponent } from './components/admin/translation-admin.component';
import { InvoicesV2ListComponent } from './Data/invoices-v2/invoices-v2-list/invoices-v2-list.component';
import { InvoicesV2FormComponent } from './Data/invoices-v2/invoices-v2-form/invoices-v2-form.component';
import { InvoicesV2ViewComponent } from './Data/invoices-v2/invoices-v2-view/invoices-v2-view.component';
import { InvoiceV2UnsavedGuard } from './Data/invoices-v2/guards/invoice-v2-unsaved.guard';
import { AiVoiceInvoiceComponent } from './Data/ai-voice-invoice/ai-voice-invoice.component';
import { AdminMerchantSubscriptionsComponent } from './Data/plans-info/admin-merchant-subscriptions/admin-merchant-subscriptions.component';
import { AdminCustomPaymentsComponent } from './Data/plans-info/admin-custom-payments/admin-custom-payments.component';
import { ExpensePlansComponent } from './Data/expense-plans/expense-plans.component';
import { AdminAppVersionComponent } from './Data/admin-app-version/admin-app-version.component';

const routes: Routes = [
	{ path: "", redirectTo: "home", pathMatch: "full" },
	{path:'home' , component:HomeComponent},
	{ path: 'landing', component: CampaignLandingComponent },
	{ path: 'update-receipt/:id', component: UpdateReceiptComponent },
	{ path: 'pricing', component: SubPlansComponent },
	{ path: 'articles/:id', component: ThiArticleDetailComponent },
	{ path: 'articles', component: ThiArticlesComponent },
	{path:"about" , component:AboutComponent},
	{path:"support" , component:SupportComponent},
	{path:'terms' , component:TermsAndConditionsComponent},
	{path:'privacy-policy' , component:PrivacyPolicyComponent},
	{path:'terms-of-service' , component:TermsOfServiceComponent},
	{path:"register" , component:RegisterComponent},
	{path:"login" , component:LoginComponent},
	{path:"forgot-password" , component:ForgotPasswordComponent},
	{path:"auth/auto-login/:token" , component:AutoLoginComponent},
	{path: 'otp', component: OtpComponent},
	{ path: 'plans', component: PlansComponent },
	{ path: 'checkout', component: CheckoutComponent },
	{path: 'resend-otp', component: ResendotpComponent},
	{
		path: 'shared/folder/:token',
		loadChildren: () => import('./shared-storage/shared-folder/shared-folder.module').then(m => m.SharedFolderModule),
	},
	{
		path: "dashboard",
		component: ContentComponent,
		canActivate: [AuthGuard],
		children: [
			{path:'first-page' , component:FirstPageComponent, canActivate: [AdminGuard]},
			{path:'dashboard' ,component: DashboardComponent},
			{path:'terms-and-conditions' , component:TermsComponent , canActivate: [AdminGuard]},
			{ path: 'update-receipt/:id', component: UpdateReceiptComponent },
			{path:'plan-details/:id', component: PlaneDetailsComponent, },
			{path: 'merchant-info', component: MerchantComponent},
			{path: 'merchant-payment', component: MerchantPaymentComponent},
      {path: 'invoice-subscriptions', component: MerchantSubscriptionsComponent},
			{path: 'trusted-devices', component: TrustedDevicesComponent},
			{path: 'update-merchant/:id', component: UpdateMerchantComponent},
			{path: 'view-merchant/:id', component: ViewMerchantComponent},
			{path: 'all-merchant-users/:id', component: AllMerchantUsersComponent},
			{path:'companies' , component:CompanyComponent},
			{path:'view-company/:id' , component:ViewCompanyComponent},
			{path:'update-company/:id' , component:UpdateCompanyComponent},
			{path:'documents/:id' , component:DocumentsComponent},
			{path:'more-info-company/:id' , component:MoreInfoCompanyComponent},
			{path:'vat-list' , component:VatListComponent, canActivate: [AdminGuard]},
			{path:'admin-expense-quota' , component:AdminExpenseQuotaComponent, canActivate: [AdminGuard]},
		{path:'admin-app-version' , component:AdminAppVersionComponent, canActivate: [AdminGuard]},
			{ path: 'admin-push-notifications', redirectTo: 'admin/notifications', pathMatch: 'full' },
			{
				path: 'admin',
				component: AdminOutletComponent,
				children: [
					{
						path: 'notifications',
						component: AdminPushNotificationsComponent,
						canActivate: [AdminGuard],
					},
				],
			},
			{path:'vat-list-details/:id' , component:VatListDetailsComponent,},
			{path:'categories' , component:CategoriesComponent, canActivate: [AdminGuard]},
			{path:'plans-info' , component:PlansInfoComponent, canActivate: [AdminGuard]},
			{path:'admin-merchant-subscriptions' , component:AdminMerchantSubscriptionsComponent, canActivate: [AdminGuard]},
			{path:'admin-custom-payments' , component:AdminCustomPaymentsComponent, canActivate: [AdminGuard]},
			{path:'expense-plans' , component:ExpensePlansComponent, canActivate: [AdminGuard]},
			{path:'customers' , component:CustomersComponent},
			{path:'customers/:customerId/account-card' , component:CustomerAccountCardComponent},
			{path:'customer-balances' , component:CustomerBalancesComponent},
			{path:'customer-account-entries' , component:CustomerAccountEntriesComponent},
			{path:'checks-report' , component:ChecksReportComponent},
			{path:'accountants' , component:AccountantsComponent},
			{path:'company-documents/:id' , component:CompanyDocumentsComponent},
			{path:'closed-month/:id' , component:ClosedMonthComponent},
			{path:'document-pdf/:id' , component:DocumentPdfComponent},
			{path:'export-reports/:id' , component:ExportReportsComponent},
			{path:'upload-allocation-number', component:UploadAllocationNumberComponent},
			{path:'products' , component:ProductsComponent},
			{path:'products/new' , component:ProductFormComponent},
			{path:'products/edit/:id' , component:ProductFormComponent},
			{path:'merchant-product-categories' , component:MerchantProductCategoriesComponent},
			{path:'upload-permanent-file' , component:UploadPermanentFileComponent},
			{path:'expenses' , loadChildren: () => import('./Data/expenses/expenses.module').then(m => m.ExpensesModule)},
			{path:'tasks' , loadChildren: () => import('./Data/tasks/tasks.module').then(m => m.TasksModule)},
			{path:'merchant-storage' , loadChildren: () => import('./Data/merchant-storage/merchant-storage.module').then(m => m.MerchantStorageModule)},
			{path:'payment-collections' , loadChildren: () => import('./Data/payment-collections/payment-collections.module').then(m => m.PaymentCollectionsModule)},
			{path:'fee-agreements' , loadChildren: () => import('./Data/fee-agreements/fee-agreements.module').then(m => m.FeeAgreementsModule)},
			{path:'merchant-tasks', redirectTo: 'tasks/merchant', pathMatch: 'full'},
			{path:'merchant-tasks/:id', redirectTo: 'tasks/merchant/:id'},
			{path:'office-tasks', redirectTo: 'tasks/office', pathMatch: 'full'},
			{path:'office-tasks/:id', redirectTo: 'tasks/office/:id'},
			{path:'admin-tasks', redirectTo: 'tasks/admin', pathMatch: 'full'},
			{path:'admin-tasks/audit', redirectTo: 'tasks/admin/audit', pathMatch: 'full'},
			{path:'admin-tasks/stats', redirectTo: 'tasks/admin/stats', pathMatch: 'full'},
			{path:'admin-tasks/:id', redirectTo: 'tasks/admin/:id'},
			{path:'reports-gain-loss' , loadChildren: () => import('./Data/reports-gain-loss/reports-gain-loss.module').then(m => m.ReportsGainLossModule)},
			{path:'history' , component:HistoryComponent},
			{path:'history-details/:id' , component:HistoryDetailsComponent},
			{path:'measurement-units' , component:MeasurementUnitsComponent , canActivate: [AdminGuard]},
			{path:'users' , component:UsersComponent },
			{path:'user-privileges/:id' , component:UsersPrivilegesComponent},
			{path:'invoices-types' , component:InvoicesTypesComponent , canActivate: [AdminGuard]},
			{path:'receipts' , component:ReceiptsComponent},
			{path:'export-receipt-pdf/:id' , component:ExportReceiptPdfComponent},
			{path:'permanent-file' , component:PermanentFileComponent},
			{path:'application-info' , component:AppInfoComponent , canActivate: [AdminGuard]},
			{path:'banks' , component:BanksComponent, canActivate: [AdminGuard]},
			{path:'accounting-offices' , component:AccountingOfficesComponent, canActivate: [AdminGuard]},
			{path:'accounting-offices-companies/:id' , component:AccountingOfficesCompaniesComponent },
			{path:'all-office-users/:id' , component:AllUsersOfficeComponent },
			{path:'banks-branches/:id' , component:BanksBranchesComponent, },
			{path:'payment-method' , component:PaymentMethodComponent, canActivate: [AdminGuard]},
			{path:'invoices' , component:InvoicesComponent},
			{path:'mission' , component:MissionComponent},
			{path:'order' , component:OrderComponent},
			{path:'offer-price' , component:OfferPriceComponent},
			{path:'reverce-invoice' , component:ReverceInvoiceComponent},
			{path:'reversereceipt' , component:ReversereceiptComponent},
			{path:'export-reverce-invoice-pdf/:id' , component:ExportReverceInvoicePdfComponent},
			{path:'export-pdf/:id' , component:ExportPdfComponent},
			{path:'notification-details' , component:NotificationDetailsComponent},
			{path:'notifications' , component:NotificationCenterComponent},
			{path:'all-warning' , component:AllWarningComponent},
			{path:'terms-and-conditions' , component:TermsAndConditionsComponent, canActivate: [AdminGuard]},
			{path:'office' , component:OfficeComponent},
			{path:'office-users' , component:OfficeUsersComponent},
			{path:'office-users-privileges/:id' , component:OfficeUsersPrivilegesComponent},
			{path:'office-companies' , component:OfficeCompaniesComponent},
			{path:'accountant-user-companies/:id' , component:AccountantUserCompaniesComponent},
			{path:'company-employee/:id' , component:CompanyEmployeeComponent},
			{ path: 'sequanse/:id', component: SequanseComponent },
			{ path: 'documents', canActivate: [DocumentsRedirectGuard], component: InvoicesV2ListComponent },
			{ path: 'add-offer-price' , component:DocumentComponent, data: { docType: '0' }},
			{ path: 'add-order' , component:DocumentComponent, data: { docType: '100' }},
			{ path: 'add-mission' , component:DocumentComponent, data: { docType: '200' }},
			{ path: 'add-invoice' , component:DocumentComponent, data: { docType: '305' }},
			{ path: 'add-invoice-with-receipt', component:DocumentComponent, data: { docType: '320' }},
			{ path: 'add-reverce-invoice', component:DocumentComponent, data: { docType: '330' }},
			{ path: 'add-finaical-request', component:DocumentComponent, data: { docType: '332' }},
			{ path: 'add-receipts' , component:DocumentComponent, data: { docType: '400' }},
			{ path: 'document/:id', component: DocumentComponent }, // For edit documents
			{ path: 'translations', component: TranslationAdminComponent },
			// Invoices V2 Routes (support both invoices-v2 and Invoices-v2 for shared links)
			{ path: 'invoices-v2', component: InvoicesV2ListComponent },
			{ path: 'Invoices-v2', component: InvoicesV2ListComponent },
			{ path: 'invoices-v2/create', component: InvoicesV2FormComponent, canDeactivate: [InvoiceV2UnsavedGuard] },
			{ path: 'invoices-v2/edit/:id', component: InvoicesV2FormComponent },
			{ path: 'invoices-v2/view', component: InvoicesV2ViewComponent },
			{ path: 'Invoices-v2/view', component: InvoicesV2ViewComponent },
			{ path: 'business-insights', loadChildren: () => import('./Data/business-insights/business-insights.module').then(m => m.BusinessInsightsModule) },
			{ path: 'ai-voice-invoice', component: AiVoiceInvoiceComponent },
			{ path: 'company-template-designer', loadChildren: () => import('./company-template-designer/company-template-designer.module').then(m => m.CompanyTemplateDesignerModule) },
			{ path: 'old-add-invoice' , component:AddInvoiceComponent},
			{ path: 'old-update-invoice/:id' , component:AddInvoiceComponent},
			{ path: 'old-add-mission' , component:AddMissionComponent},
			{ path: 'old-update-mission/:id' , component:UpdateMissionComponent},
			{ path: 'old-add-order' , component:AddOrderComponent},
			{ path: 'old-update-order/:id' , component:UpdateOrderComponent},
			{ path: 'old-add-offer-price' , component:AddOfferPriceComponent},
			{ path: 'old-update-offer-price/:id' , component:UpdateOfferPriceComponent},
			{ path: 'old-add-reverce-invoice' , component:AddReverceInvoiceComponent},
			{ path: 'old-update-reverce-invoice/:id' , component:UpdateReverceInvoiceComponent},
			{ path: 'old-documents', component: MerchantDocumentsComponent},
			{ path: 'old-invoice-with-receipt', component: InvoiceAndReceiptComponent },
			{ path: 'old-add-invoice-with-receipt', component: AddInvoiceWithReceiptComponent },
			{ path: 'old-update-invoice-with-receipt/:id', component: UpdateInvoiceWithReceiptComponent },
			{ path: 'old-export-invoice-with-receipt-pdf/:id' , component:ExportInvoiceWithReceiptPdfComponent},
			{ path: 'old-finaical-request', component:FinaicalRequestComponent},
			{ path: 'old-update-finaical-request/:id', component:UpdateFinaicalRequestComponent},
			{ path: 'old-export-finaical-request-pdf/:id' , component:ExportFinaicalRequestPdfComponent},
			{path:'old-add-receipts' , component:AddReceiptsComponent},
		]

	},

	{path: '**', component: Error404Component}

];
@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			anchorScrolling: "enabled",
			scrollPositionRestoration: "enabled",
			useHash: true,
			/* 'reload' re-ran route resolvers/destroyed+recreated components on same URL and can contribute to jank or feedback loops. */
			onSameUrlNavigation: 'ignore',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
